<template>
  <div class="novelList">
    <NovelListItem
      v-for="(novelData, index) in novelDatas" 
      v-bind:novelData="novelData" 
      v-bind:key="index"></NovelListItem>
  </div>
</template>

<script>
import NovelListItem from './NovelListItem'

var _novelDatas = require('../../../assets/data/NovelDatas.json');
export default {
  name: 'NovelListControll',
  components: {
    NovelListItem
  },
  data(){
    return{
      novelDatas: _novelDatas
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.novelList{
  width: 100%;
  height: calc(100% - 30px);
  margin: 0;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content:space-evenly;
  position: absolute;
  top: 0;
  left:0;
  overflow-y: auto;
}
</style>
